import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';

import { AlertController } from '@ionic/angular';

import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { UrlService } from '@shared/services/url.service';
import { filter } from 'rxjs/operators';
import { StorageService } from '@core/services/native/storage.service';
import { NavigationService } from '@core/services/native/navigation.service';
import { Platform } from "@ionic/angular";

import { environment } from '../environments/environment';

import { UpdaterService } from '@core/services/updater.service';

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent implements OnInit {

  // --- Public Properties ---

  public currentDate: string;
  public worker: any;
  public currentLanguage: string;
  public version: string = environment.version;

  // --- Private Properties ---

  private previousUrl: string = null;
  private currentUrl: string = null;

  // --- Constructor ---

  constructor(
    private router: Router,
    private urlService: UrlService,
    private alertController: AlertController,
    private datePipe: DatePipe,
    private storageService: StorageService,
    public navigationService: NavigationService,
    public translate: TranslateService,
    private platform: Platform,
    private updaterService: UpdaterService // Inject UpdaterService
  ) {
    this.currentLanguage = localStorage.getItem("lang") || "it";

    switch (this.currentLanguage) {
      case "en":
        this.setupLanguage();
        break;

      default:
        this.setupLanguage();
        break;
    }
  }

  // --- Lifecycle Hooks ---

  ngOnInit(): void {
     this.platform.ready().then(() => {
       window.dispatchEvent(new Event("resize"));
     });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        this.urlService.setPreviousUrl(this.previousUrl);
      });

    this.clearData();

    this.storageService.getWorker().subscribe({
      next: (worker: string) => {
        this.worker = JSON.parse(worker);
        if (this.worker == null) {
          this.worker = JSON.parse(localStorage.getItem("worker") || "{}");
        }
      },
    });
  }

  // --- Public Methods ---

  public async switchLanguageToEnglish() {
    const alert = await this.alertController.create({
      subHeader: "Passare alla lingua inglese?",
      buttons: [
        {
          text: "No",
          role: "cancel",
        },
        {
          text: "Si",
          role: "confirm",
          handler: () => {
            this.currentLanguage = "en";
            this.setupLanguage();
          },
        },
      ],
    });

    await alert.present();
  }

  public async switchLanguageToItalian() {
    const alert = await this.alertController.create({
      subHeader: "Do you confirm to change language to italian?",
      buttons: [
        {
          text: "No",
          role: "cancel",
        },
        {
          text: "Yes",
          role: "confirm",
          handler: () => {
            this.currentLanguage = "it";
            this.setupLanguage();
          },
        },
      ],
    });

    await alert.present();
  }

  // --- Private Methods ---

  private loadCurrentDate(): void {
    this.currentDate = this.datePipe.transform(
      new Date(),
      "dd MMMM yyyy",
      "UTC",
      this.currentLanguage
    );
  }

  private setupLanguage(): void {
    localStorage.setItem("lang", this.currentLanguage);

    this.translate.setDefaultLang(this.currentLanguage);
    this.translate.use(this.currentLanguage);

    this.loadCurrentDate();
  }

  private clearData() {
    this.storageService.setWorker(null);
    //this.storageService.remove('worker');
  }
}
